import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter';
import { END_POINT_LLM_SERVICE } from '@/constants';

type CodeSnippetProps = {
  model: string;
  apiKey?: string;
  endpoint?: string;
};
const CodeOpenAI = ({ model, apiKey = '<your API key>', endpoint = END_POINT_LLM_SERVICE }: CodeSnippetProps) => {
  return (
    <div className="flex flex-col gap-2">
      <li>Install the OpenAI package:</li>
      <SyntaxHighlighter language="bash" wrapLongLines showCopy>
        pip install openai
      </SyntaxHighlighter>
      <li>Use the following Python code snippet:</li>
      <SyntaxHighlighter language="python" wrapLongLines showCopy>
        {`import httpx
import openai

FLOAT16_BASE_URL = "${endpoint}"
FLOAT16_API_KEY = "${apiKey}"

client = openai.OpenAI(
    api_key=FLOAT16_API_KEY,
    base_url=FLOAT16_BASE_URL,
)
client._base_url = httpx.URL(FLOAT16_BASE_URL)

# Streaming chat:
messages = [{"role": "system", "content": "You are truly awesome."}]

while True:
    content = input(f"User:")
    messages.append({"role": "user", "content": content})
    print(f"Assistant:", sep="", end="", flush=True)
    content = ""

    for chunk in client.chat.completions.create(
        messages=messages,
        model="${model}",
        stream=True,
    ):
        delta_content = chunk.choices[0].delta.content
        if delta_content:
            print(delta_content, sep="", end="", flush=True)
            content += delta_content
    
    messages.append({"role": "assistant", "content": content})
    print("\\n")`}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeOpenAI;
